<template>
  <!-- 作物发布-数据总览·二级页面 -->
  <div>
    <div id="num_farming" ref="farming">
      <div class="echarts_border">
        <!-- 图例 -->
        <div class="echart_zonglans">
          <div class="echarts_font">
            <img :src="icon_font" class="icon_img" alt="" />
            <span class="people_font">2021年平罗县农作物种植面积</span>
          </div>
        </div>
        <div id="echart_farming_one"></div>
        <!-- 表格 -->
        <div class="echart_zonglan">
          <div class="echarts_font">
            <img :src="icon_font" class="icon_img" alt="" />
            <span class="people_font">面积单位：亩</span>
          </div>
        </div>
        <table class="table_cont" border="1" cellpadding="0">
          <tr
            style="color: #1eeabe; background: #0a4960; border-color: #0a4960;position: sticky;
  top: 0;
  z-index: 2;"
          >
            <td style="width: 100px">乡镇</td>
            <td>苜蓿</td>
            <td>玉米</td>
            <td>水稻</td>
            <td>小麦</td>
            <td>大棚</td>
            <td>蔬菜</td>
            <td>小麦/苜蓿</td>
            <td>小麦/玉米</td>
            <td style="color:#55F8FF">合计</td>
          </tr>
          <tr v-for="(item, index) in tableList" :key="index" :style="{'color':index==14?'#55F8FF':''}">
            <td>{{ item.village }}</td>
            <td>{{ item.alfalfa }}</td>
            <td>{{ item.corn }}</td>
            <td>{{ item.rice }}</td>
            <td>{{ item.wheat }}</td>
            <td>{{ item.greenhouse}}</td>
            <td>{{ item.vegetable }}</td>
            <td>{{ item.wheatAndAlfalfa }}</td>
            <td>{{ item.wheatAndCorn}}</td>
            <td style="color:#55F8FF">{{ item.xsum}}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  data() {
    return {
      icon_font: require("@/assets/images/icon_font.png"),
      // 表格接口数据
      tableList: [
        {
          theYear2: "马场村",
          theYear: "100",
          carNumber: "105",
          areaNumber: "105",
          companyNumber: "105",
          theYear1: "105",
          carNumber1: "105",
          areaNumber1: "105",
          companyNumber1: "105",
        },
        {
          theYear2: "马场村",
          theYear: "100",
          carNumber: "105",
          areaNumber: "105",
          companyNumber: "105",
          theYear1: "105",
          carNumber1: "105",
          areaNumber1: "105",
          companyNumber1: "105",
        },
        {
          theYear2: "马场村",
          theYear: "100",
          carNumber: "105",
          areaNumber: "105",
          companyNumber: "105",
          theYear1: "105",
          carNumber1: "105",
          areaNumber1: "105",
          companyNumber1: "105",
        },
        {
          theYear2: "马场村",
          theYear: "100",
          carNumber: "105",
          areaNumber: "105",
          companyNumber: "105",
          theYear1: "105",
          carNumber1: "105",
          areaNumber1: "105",
          companyNumber1: "105",
        },
        {
          theYear2: "马场村",
          theYear: "100",
          carNumber: "105",
          areaNumber: "105",
          companyNumber: "105",
          theYear1: "105",
          carNumber1: "105",
          areaNumber1: "105",
          companyNumber1: "105",
        },
        {
          theYear2: "马场村",
          theYear: "100",
          carNumber: "105",
          areaNumber: "105",
          companyNumber: "105",
          theYear1: "105",
          carNumber1: "105",
          areaNumber1: "105",
          companyNumber1: "105",
        },
        {
          theYear2: "马场村",
          theYear: "100",
          carNumber: "105",
          areaNumber: "105",
          companyNumber: "105",
          theYear1: "105",
          carNumber1: "105",
          areaNumber1: "105",
          companyNumber1: "105",
        },
        {
          theYear2: "马场村",
          theYear: "100",
          carNumber: "105",
          areaNumber: "105",
          companyNumber: "105",
          theYear1: "105",
          carNumber1: "105",
          areaNumber1: "105",
          companyNumber1: "105",
        },
        {
          theYear2: "马场村",
          theYear: "100",
          carNumber: "105",
          areaNumber: "105",
          companyNumber: "105",
          theYear1: "105",
          carNumber1: "105",
          areaNumber1: "105",
          companyNumber1: "105",
        },
        {
          theYear2: "马场村",
          theYear: "100",
          carNumber: "105",
          areaNumber: "105",
          companyNumber: "105",
          theYear1: "105",
          carNumber1: "105",
          areaNumber1: "105",
          companyNumber1: "105",
        },
        {
          theYear2: "马场村",
          theYear: "100",
          carNumber: "105",
          areaNumber: "105",
          companyNumber: "105",
          theYear1: "105",
          carNumber1: "105",
          areaNumber1: "105",
          companyNumber1: "105",
        },
        {
          theYear2: "马场村",
          theYear: "100",
          carNumber: "105",
          areaNumber: "105",
          companyNumber: "105",
          theYear1: "105",
          carNumber1: "105",
          areaNumber1: "105",
          companyNumber1: "105",
        },
        {
          theYear2: "马场村",
          theYear: "100",
          carNumber: "105",
          areaNumber: "105",
          companyNumber: "105",
          theYear1: "105",
          carNumber1: "105",
          areaNumber1: "105",
          companyNumber1: "105",
        },
        {
          theYear2: "马场村",
          theYear: "100",
          carNumber: "105",
          areaNumber: "105",
          companyNumber: "105",
          theYear1: "105",
          carNumber1: "105",
          areaNumber1: "105",
          companyNumber1: "105",
        },
      ],
      // 数据来源
      Data_txt: "",
      Data_txtTwo: "",
    };
  },
  created() {},
  mounted() {
    this.init_one();
    this.init_two();
    this.Sources();
  },
  methods: {
    // 图例
    init_one() {
      var data1 = plOtherDataInterface.getVegetableAreaPie();
      console.log(data1);
      var myChart1 = echarts.init(
        document.getElementById("echart_farming_one")
      );
      var option = {
        tooltip: {
          trigger: "item",
          formatter: "{b}: {c} 亩 ({d}%)",
        },
        color: [
          "#FB7960",
          "#6FC5FF",
          "#FF7CA3",
          "#FFBB80",
          "#B6A2DE",
          "#3FC7BE",
          "#FFF8DC",
          "#CEFE65",
          "#F9FE5C",
        ],
        series: [
          {
            name: "访问来源",
            type: "pie",
            radius: "95%",
            center: ["50%", "50%"],
            z: 666,
            data: data1,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            label: {
              show: true,
              formatter: "{b} {d}%",
              padding: [-20, -30, -10, -30], //设置外部文字的位置
              color: "#fff", // 改变标示文字的颜色
              rich: {
                b: {
                  fontWeight: 500,
                  lineHeight: 16,
                },
              },
            },
            labelLine: {
              //label线的长度
              normal: {
                length: 40, // 改变标示线的长度
                length2: 100,
                maxSurfaceAngle: 90,
                minTurnAngle: 90,
                lineStyle: {
                  color: "#fff", // 改变标示线的颜色
                },
              },
            },
          },
          {
            type: "pie",
            radius: ["99%", "100%"],
            name: "",
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
            data: [
              {
                name: "",
                value: 0,
                itemStyle: {
                  normal: {
                    color: "#fff",
                  },
                },
              },
            ],
          },
        ],
      };
      option && myChart1.setOption(option);
    },
    // 表格
    init_two() {
      // 调取数据
      this.tableList = plOtherDataInterface.getVegetableAreaList();
    },
  },
};
</script>

<style lang="less" scoped>
#num_farming {
  background: #15606e;
}
.echarts_border {
  height: 39rem;
  overflow: auto;
  scrollbar-face-color: #0e4560;
}
.echart_zonglans {
  margin: 1.875rem 0 0 0;
  border-top: 1px solid rgb(121, 226, 154);
  padding-top: 1.875rem;
}
.echart_zonglan {
  margin: 1.875rem 0 0 0;
  border-top: 1px dashed rgb(121, 226, 154);
  padding-top: 1rem;
}
#echart_farming_two,
#echart_farming_one {
  height: 20rem;
}
.echarts_font {
  text-align: left;
      margin-bottom: 2rem;
}
.icon_img {
  width: 25px;
  height: 25px;
  margin-right: 0.4375rem;
  vertical-align: sub;
}
.people_font {
  font-size: 24px;
  color: rgb(62, 248, 156);
}
.text-center {
  text-align: center;
  font-size: 16px;
  color: #d3d3d3;
}
::-webkit-scrollbar {
  background-color: #15606e;
  width: 5px;
} /* 这是针对缺省样式 (必须的) */
::-webkit-scrollbar-thumb {
  background: #00574a;
  width: 5px;
  border-radius: 10px;
} /* 滑块颜色 */

// 表格样式
.table {
  background: #0a4960;
  color: rgb(125, 243, 164);
  font-size: 1.2rem;
  width: 100%;
  text-align: center;
}
.table_cont {
  width: 100%;
  border-collapse: collapse;
  color: #fff;
  font-size: 16px;
  border-color: #83aabe;
  td {
    padding: 10px 0;
    width: 10%;
    font-weight: 300 !important;
  }
}
.table_cont tr {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/cutline/details/detail_data.vue